import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import listaFiltrosItinerarioEmbarque from '../../actions/itinerario/listaFiltrosItinerarioEmbarque'
import adicionarItinerarioEmbarque from '../../actions/itinerario/adicionarItinerarioEmbarque'
import removerFiltroItinerarioEmbarque from '../../actions/itinerario/removerFiltroItinerarioEmbarque'
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import FiltroBuscarEmbarquePassageiro from './FiltroBuscarEmbarquePassageiro'
import FiltroChaveValor from '../comum/FiltroChaveValor';
import { 
  FILTRO_DATA_PARTIDA,
  FILTRO_VENDAS_ITINERARIO,
  FILTRO_STATUS_ITINERARIO,
  FILTRO_VEICULO,
  FILTRO_PRESTADOR,
  FILTRO_TIPO_PRECO
 } from '../../util/filtros'

export class FiltroItinerarioEmbarque extends Component {
  
  componentDidMount () {
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.props.listaFiltrosItinerarioEmbarque(this.props.empresaSelecionada.id)
    }
  }

  componentDidUpdate (prevProps) {
    if (alterouEmpresa(this.props, prevProps)) {
      this.props.listaFiltrosItinerarioEmbarque(this.props.empresaSelecionada.id)
    }
  }


  adicionarFiltro (filtro) {
    this.props.adicionarItinerarioEmbarque(filtro)
  }

  removerFiltro (filtro) {
    this.props.removerFiltroItinerarioEmbarque(filtro)
  }

  render () {
    return (
      <React.Fragment>
        <div className="conteudo">
          <FiltroBuscarEmbarquePassageiro
            filtro={FILTRO_DATA_PARTIDA}
            opcoes={[new Date().getFullYear()]}
            isFiltroData={true}
          />
          <FiltroBuscarEmbarquePassageiro 
            filtro={FILTRO_VENDAS_ITINERARIO}
            opcoes={['Com vendas', 'Sem vendas']}
            isRadio={true}
          />
          <FiltroBuscarEmbarquePassageiro 
            filtro={FILTRO_STATUS_ITINERARIO}
            opcoes={['Ativo', 'Inativo']}
            isRadio={true}
          />
          <FiltroBuscarEmbarquePassageiro 
            filtro={FILTRO_VEICULO}
            opcoes={[]}
            isNome={true}
          />
          <FiltroBuscarEmbarquePassageiro 
            filtro={FILTRO_PRESTADOR}
            opcoes={[]}
            isNome={true}
          />
          <FiltroChaveValor
            filtro={FILTRO_TIPO_PRECO}
            opcoes={this.props.tipoPrecos}
            filtrosAdicionados={this.props.filtrosAdicionados}
            adicionarFiltro={this.adicionarFiltro.bind(this)}
            removerFiltro={this.removerFiltro.bind(this)}
          />
        </div>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = state => ({
  filtrosAdicionados: state.filtrosAdicionadosItinerarioEmbarque,
  empresaSelecionada: state.empresaSelecionada,
  tipoPrecos: state.filtrosItinerarioEmbarque.tipoPrecos
})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarItinerarioEmbarque,
    removerFiltroItinerarioEmbarque,
    listaFiltrosItinerarioEmbarque
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroItinerarioEmbarque)
